const translations = {
  cz: {
    vaseFiltry: 'Vaše filtry',
    vasEmail: "Vložte váš e-mail",
    odebiratnewsletter: "Odebírat",
    overeneHodnoceni: "Ověřený zákazník",
    openHour: "(po-pá, 9-17:00)",
    searchPlaceholder: "Co hledáte? Např. Macbook Pro, iPhone",
    menu: "MENU",
    zobrazitDalsiVMenu: "Zobrazit další",
    pro: "pro",
    registrovane: "registrované",
    zobrazitMene: "Zobrazit méně",
    minCteni: "min. čtení",
    popisProduktu: "Popis produktu",
    parametryProduktu: "Parametry produktu",
    nepotrebujete: "Nepotřebujete ještě něco?",
    najdeteZde: "Produkt najdete v těchto kategoriích:",
    jsmeTu: "Jsme tu, když si nevíte rady",
    poradit: "Naši specialisté jsou připraveni poradit s výběrem",
    viceInformaci: "Více informací",
    vsechnyKontakty: "Všechny kontakty",
    hodnoceniProduktu: "Hodnocení produktu",
    kod: "Kód",
    cistVice: "Číst více",
    cistMene: "Číst méně",
    rozbalitVse: "Rozbalit vše",
    rozbalitMene: "Rozbalit méně",
    dleStitku: "Dle štítku",
    continueToOrder: "Pokračovat v objednávce",
    darekKobj: "Dárek k objednávce zdarma",
    zdarma: "zdarma",
    produktKosik: "Název produktu",
    dostupnost: "Dostupnost",
    pocet: "Množství",
    cenaZaKus: "Cena za kus",
    sleva: "Sleva",
    celkem: "Celkem",
    mateUcet: "Máte u nás účet? Přihlaste se  údaje se vyplní automaticky.",
    prihlasitSe: "Přihlásit se",
    objednavkaPrijata: "Vaši objednávku jsme v pořádku přijali",
    dekujemeZaObjednavku: "Děkujeme za vaši objednávku. Nyní jdeme vše nachystat tak, aby byla co nejdříve u vás.",
    cisloObjednavky: "Číslo objednávky: ",
    zpetDoObchodu: "Zpět do obchodu",
    odebratKupon: 'Odebrat kupón',
    koupit: 'Koupit',
    nepotrebujeteNeco: 'Nepotřebujete ještě něco?',
    usetrili: 'Ušetřili jste',
    opravduOdstranit: 'Opravdu chcete produkt odstranit? <br>Možná už nebude.',
    odebrat: 'Odebrat',
    ponechat: 'Ponechat',
    zapomenuteHeslo: 'Zapomněli jste heslo?',
    email: 'Váš e-mail:',
    heslo: 'Heslo:',
    neboSePrihlastePomoci: 'nebo se přihlaste přes',
    prihlaseniKVasemuUctu: 'Přihlášení k vašemu účtu:',
    registraciZiskate: 'Registrací získáte skvělé výhody',
    uzMateUcet: 'Už u nás máte účet?',
    registrovatSe: 'Registrovat se',
    neboSeRegistrujtePres: 'nebo se registrujte přes',
    prazdnyKosik: 'Váš košík je zatím prázdný',
    sTimtoProduktem: 'S tímto produktem zákazníci nejčastěji kupují',
    zrusitfiltry: 'Zrušit všechny filtry',
    vyberteKategorii: 'vyberte si podkategorii',
    clankyKat: 'Související články',
    zobrazeno: 'Zobrazeno',
    produkt: 'produkt',
    produkty: 'produkty',
    produktu: 'produktů',
    z: 'z',
    predchozi: 'Předchozí',
    dalsi: 'Další',
    faq: 'Časté dotazy',
    souvysejiciProdukty: 'Související produkty',
    VlozitDoKosiku: 'Vložit do košíku',
    zaruka: 'Záruka',
    dotazkProduktu: 'Dotaz k produktu',
    hlidat: 'Hlídací pes',
    darekZdarma: 'Dárek ZDARMA k tomuto produktu',
    znacka: 'Značka',
    splatky: 'Na splátky již',
    mesicne: 'měsíčně',
    spocitatSplatky: 'Spočítat splátky',
    od: 'od',
    procmameceny: 'Proč máme takové ceny dopravy?',
    doruceniDo: 'Doručení do',
    zobrazitnamape: 'Zobrazit na mapě',
    ilustracni: 'Ilustrační obrázek',
    hodnoceni: 'Hodnocení',
    kodLabel: 'Kód produktu:',
    strana: 'strana-',
    TypZbozi: 'Typ zboží',
    cenavkc: 'cena kč',
    porovnatProdukt: 'Porovnat',
    bezDPH: 'bez DPH',
    osvobozeno: 'Osvobozeno od DPH',
    detail: 'Detail',
    obsahbaleni: 'Obsah balení',
    nabijeciadapter: 'Napájecí adaptér, síťový kabel',
    zobrazit: 'Zobrazit',
    zrusitVse: 'Zrušit vše',
    filtrovat: 'Filtrovat',
    stanteSeFanousky: 'Staňte se našimi fanoušky',
    cena: 'Cena',
    nacitamInfo: 'Načítám informace...',
    nepodarilosenacist: 'Detailní informace se nepodařilo načíst.',
    pridatHodnoceni: 'Přidat hodnocení',
    vaseHodnoceni: 'Vaše hodnocení',
    spokojenost: 'Jak jste s produktem spokojeni?',
    raditDle: 'Řadit dle'
  },

  sk: {
    vaseFiltry: 'Vaše filtre',
    vasEmail: 'Vložte váš e-mail',
    odebiratnewsletter: 'Odoberať',
    overeneHodnoceni: 'Overený zákazník',

    openHour: '(po-pia, 9-17:00)',
    searchPlaceholder: 'Čo hľadáte? Napr. Macbook Pro, iPhone',
    menu: 'MENU',
    zobrazitDalsiVMenu: 'Zobraziť ďalšie',
    pro: 'pre',
    registrovane: 'registrované',
    zobrazitMene: 'Zobraziť menej',
    minCteni: 'min. čítania',
    popisProduktu: 'Popis produktu',
    parametryProduktu: 'Parametre produktu',
    nepotrebujete: 'Nepotrebujete ešte niečo?',
    najdeteZde: 'Produkt nájdete v týchto kategóriách:',
    jsmeTu: 'Sme tu, keď si neviete rady',
    poradit: 'Naši špecialisti sú pripravení poradiť s výberom',
    viceInformaci: 'Viac informácií',
    vsechnyKontakty: 'Všetky kontakty',
    hodnoceniProduktu: 'Hodnotenie produktu',
    kod: 'Kód',
    cistVice: 'Čítať viac',
    cistMene: 'Čítať menej',
    rozbalitVse: 'Rozbaliť všetko',
    rozbalitMene: 'Zobraziť menej',
    dleStitku: 'Podľa štítku',
    continueToOrder: 'Pokračovať v objednávke',
    darekKobj: 'Darček k objednávke zdarma',
    zdarma: 'zdarma',
    produktKosik: 'Názov produktu',
    dostupnost: 'Dostupnosť',
    pocet: 'Množstvo',
    cenaZaKus: 'Cena za kus',
    sleva: 'Zľava',
    celkem: 'Celkom',
    mateUcet: 'Máte u nás účet? Prihláste sa, údaje sa vyplnia automaticky.',
    prihlasitSe: 'Prihlásiť sa',
    objednavkaPrijata: 'Vašu objednávku sme v poriadku prijali',
    dekujemeZaObjednavku: 'Ďakujeme za vašu objednávku. Teraz všetko pripravíme tak, aby bola čo najskôr u vás.',
    cisloObjednavky: 'Číslo objednávky: ',
    zpetDoObchodu: 'Späť do obchodu',
    odebratKupon: 'Odobrať kupón',
    koupit: 'Kúpiť',
    nepotrebujeteNeco: 'Nepotrebujete ešte niečo?',
    usetrili: 'Ušetrili ste',
    opravduOdstranit: 'Naozaj chcete produkt odstrániť? <br>Možno už nebude.',
    odebrat: 'Odobrať',
    ponechat: 'Ponechať',
    zapomenuteHeslo: 'Zabudli ste heslo?',
    email: 'Váš e-mail:',
    heslo: 'Heslo:',
    neboSePrihlastePomoci: 'alebo sa prihláste cez',
    prihlaseniKVasemuUctu: 'Prihlásenie k vášmu účtu:',
    registraciZiskate: 'Registráciou získate skvelé výhody',
    uzMateUcet: 'Už u nás máte účet?',
    registrovatSe: 'Registrovať sa',
    neboSeRegistrujtePres: 'alebo sa zaregistrujte cez',
    prazdnyKosik: 'Váš košík je zatiaľ prázdny',
    sTimtoProduktem: 'S týmto produktom zákazníci najčastejšie kupujú',
    zrusitfiltry: 'Zrušiť všetky filtre',
    vyberteKategorii: 'vyberte si podkategóriu',
    clankyKat: 'Súvisiace články',
    zobrazeno: 'Zobrazené',
    produkt: 'produkt',
    produkty: 'produkty',
    produktu: 'produktov',
    z: 'z',
    predchozi: 'Predchádzajúce',
    dalsi: 'Ďalšie',
    faq: 'Časté otázky',
    souvysejiciProdukty: 'Súvisiace produkty',
    VlozitDoKosiku: 'Pridať do košíka',
    zaruka: 'Záruka',
    dotazkProduktu: 'Otázka k produktu',
    hlidat: 'Strážny pes',
    darekZdarma: 'Darček ZDARMA k tomuto produktu',
    znacka: 'Značka',
    splatky: 'Na splátky už',
    mesicne: 'mesačne',
    spocitatSplatky: 'Vypočítať splátky',
    od: 'od',
    procmameceny: 'Prečo máme takéto ceny dopravy?',
    doruceniDo: 'Doručenie do',
    zobrazitnamape: 'Zobraziť na mape',
    ilustracni: 'Ilustračný obrázok',
    hodnoceni: 'Hodnotenie',
    kodLabel: 'Kód produktu:',
    strana: 'strana-',
    TypZbozi: 'Typ tovaru',
    cenavkc: 'cena €',
    porovnatProdukt: 'Porovnať',
    bezDPH: 'bez DPH',
    osvobozeno: 'Oslobodené od DPH',
    detail: 'Detail',
    obsahbaleni: 'Obsah balenia',
    nabijeciadapter: 'Napájací adaptér, sieťový kábel',
    zobrazit: 'Zobraziť',
    zrusitVse: 'Zrušiť všetko',
    filtrovat: 'Filtrovať',
    stanteSeFanousky: 'Staňte sa našimi fanúšikmi',
    cena: 'Cena',
    nacitamInfo: 'Načítavam informácie...',
    nepodarilosenacist: 'Detailné informácie sa nepodarilo načítať.',
    pridatHodnoceni: 'Pridať hodnotenie',
    vaseHodnoceni: 'Vaše hodnotenie',
    spokojenost: 'Ako ste s produktom spokojní?',
    souvisejiciClanky: 'Ďalšie články, ktoré by vás mohli zaujímať',
    raditDle: 'Zoradiť podľa'
  },
};

function translation(key) {
  const lang = $("html").attr("lang") || "cz";
  const parts = key.split(".");
  const requestedLang = parts.length > 1 ? parts[0] : lang;
  const realKey = parts.length > 1 ? parts[1] : parts[0];

  return translations[requestedLang] && translations[requestedLang][realKey]
    ? translations[requestedLang][realKey]
    : translations["cz"][realKey] || key;
}